import { render, staticRenderFns } from "./ActiveOrders.vue?vue&type=template&id=f0519468&scoped=true"
import script from "./ActiveOrders.vue?vue&type=script&lang=js"
export * from "./ActiveOrders.vue?vue&type=script&lang=js"
import style0 from "./ActiveOrders.vue?vue&type=style&index=0&id=f0519468&prod&lang=scss&scoped=true"
import style1 from "./ActiveOrders.vue?vue&type=style&index=1&id=f0519468&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0519468",
  null
  
)

export default component.exports